import React, { Component } from 'react';
import { Button } from 'antd';
import cx from 'classnames';

import withTranslatePlaceholder from 'components/hocs/withTranslatePlaceholder';
import withFieldWrapper from 'components/hocs/withFieldWrapper';
import { InputNumberMask } from './InputNumberMask';

@withTranslatePlaceholder
@withFieldWrapper
class InputNumberSearch extends Component {
    render() {
        const { className, input, enterButton,  onSearch} = this.props;

        return (
            <div className={cx({'fg-line': !className})}>
                <div className='number-search'>
                    <InputNumberMask
                        {...this.props}
                        className={'number-search number-search-input form-control disable-control'}
                    />
                    { enterButton && (
                        <Button
                            className='number-search-button ant-btn-primary'
                            onClick={() => onSearch(String(input.value))}
                        >
                            {enterButton}
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

export default InputNumberSearch;
